import { termosStep } from '../../shared/termosSections';
import {
  identificacaoSociedadeSection,
  enderecoAdvogadoESociedadeStep,
  DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL_ADVOGADO,
  DADOS_REQUERIMENTO_ENDERECO_PROFISSIONAL_SOCIEDADE
} from '../../shared/sociedadeSections';
import { mergeDadosRequerimentoConfig } from '../../../core/services/dadosRequerimentoConfigUtils';
import { SUBUNIDADES_OAB_MS } from '../../shared/subUnidadesOabMs';

const pedidoRegistroSociedadePluripessoalConfig = {
  id: 'pedido_registro_sociedade_pluripessoal',
  nome: 'Pedido de Registro de Sociedade Pluripessoal',
  descricao: 'Solicitação de registro de sociedade de advocacia pluripessoal',
  icon: 'FaFileContract',
  categoria: 'sociedades',
  // Só advogado(a) adimplente com a OAB/MS pode registrar sociedade (ver
  // oabData.isInadimplente no login) — checado em DynamicPedidoPage.js, que mostra
  // uma mensagem explicando o motivo em vez de esconder o pedido da listagem.
  bloqueiaInadimplente: true,

  documentConfig: {
    required: [
      { id: 'requerimento', tipoDocumentoProcesso: 433, name: 'Requerimento', description: 'Requerimento preenchido e assinado digitalmente', required: true },
      { id: 'contratoSocial', tipoDocumentoProcesso: 199, name: 'Contrato Social', description: 'Contrato social da sociedade', required: true },
      { id: 'copiaDocumentoSocios', tipoDocumentoProcesso: 373, name: 'Cópia do Documento dos Advogados Sócios', description: 'Cópia do documento de identidade de todos os advogados sócios', required: true },
      { id: 'certidaoNegativaDebito', tipoDocumentoProcesso: 534, name: 'Certidão Negativa de Débito', description: 'Certidão negativa de débito dos sócios junto à OAB/MS', required: true },
      { id: 'dbe', tipoDocumentoProcesso: 375, name: 'DBE - Documento Básico de Entrada', description: 'Documento Básico de Entrada, gerado no site da Redesim', required: true }
    ]
  },

  paymentConfig: {
    amount: 760.00,
    quantityPricing: {
      quantityField: 'quantidadeSocios',
      unitAmount: 75.00,
      baseQuantity: 2
    }
  },

  protocoloConfig: {
    modeloRequerimento: '322',
    tiposAssunto: '268',
    tipoPedido: '44',
    // Cria a PJ da sociedade (POST /pessoa/juridica) antes do /criar e manda o ID
    // dela em nomeSociedade — ver sociedadePessoaJuridicaService.js.
    criarSociedadePessoaJuridica: true
  },

  // Atualizado (2026-08): o backend passou a ter campos configurados pra esse
  // modelo (antes devolvia campos: []) — mesmo shape do Registro de Sociedade
  // Unipessoal (194), confirmado ao vivo.
  dadosRequerimentoConfig: mergeDadosRequerimentoConfig(
    {
      campos: [
        { field: 'valorCapitalSocial', campoNome: 'ValorCapitalSocial' },
        { field: 'subsecaoSociedade', campoNome: 'SubUnidadeAtual' }
      ]
    },
    DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL_ADVOGADO,
    DADOS_REQUERIMENTO_ENDERECO_PROFISSIONAL_SOCIEDADE
  ),

  tituloConfig: {
    tipoLancamentoId: 66,
    enderecoOrigem: 'residencialAdvogadoSociedade'
  },

  steps: [
    {
      id: 'dados_sociedade',
      title: 'Dados da Sociedade',
      sections: [
        identificacaoSociedadeSection([
          { type: 'currency', name: 'valorCapitalSocial', label: 'Valor do Capital Social', required: true, placeholder: 'Ex: R$ 10.000,00' },
          { type: 'select', name: 'subsecaoSociedade', label: 'Subseção da Sociedade', required: true, placeholder: 'Selecione a subseção', options: SUBUNIDADES_OAB_MS },
          { type: 'number', name: 'quantidadeSocios', label: 'Quantidade de Sócios', required: true, min: 2, step: 1, integer: true, placeholder: 'Mínimo 2' }
        ], { incluirCnpj: false })
      ]
    },
    enderecoAdvogadoESociedadeStep({ autoCep: true }),
    termosStep()
  ]
};

export default pedidoRegistroSociedadePluripessoalConfig;
